<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("stockwastageReport") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getStockWastageSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getStockWastageSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onStockWastageDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mx-2 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getStockWastageFromDate"
                  @click="
                    onStockWastageDropDownHandler({
                      event: null,
                      name: 'fromDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onStockWastageDropDownHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  :value="getStockWastageFromDate"
                  :typeable="true"
                ></Datepicker>
                <label :class="getStockWastageFromDate ? 'active' : ''">{{
                  $t("startdate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="custom-timepicker">
              <!-- <date-picker
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="Start Time"
              ></date-picker>-->
              <vue-timepicker
                manual-input
                v-model="start_time2"
                id="starttime"
                name="starttime"
                format="HH:mm"
                placeholder="Start Time"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-validate="'required'"
                @change="onChangeTime($event, 'startTime')"
              ></vue-timepicker>
              <!-- <date-picker
                    v-model="start_time"
                    @input="onStockWastageDropDownHandler({ event: $event, name: 'startTime' })"
                    type="time"
                    class="theme-custom-date-time"
                    format="hh:mm a"
                    lang="en"
                    :minute-step="1"
                    typeable
                    v-validate="'required'"
                  ></date-picker> -->
              <!-- <label :class="start_time2 ? 'active' : ''">{{ $t("starttime") }}</label> -->
            </div>
            <!-- <p class="error_msg"></p> -->
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getStockWastageToDate"
                  @click="
                    onStockWastageDropDownHandler({
                      event: null,
                      name: 'endDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onStockWastageDropDownHandler({
                      event: $event,
                      name: 'endDate',
                    })
                  "
                  :value="getStockWastageToDate"
                  :typeable="true"
                ></Datepicker>
                <label :class="getStockWastageToDate ? 'active' : ''">{{
                  $t("enddate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="custom-timepicker">
              <!-- <date-picker
                lang="en"
                type="time"
                format="hh:mm a"
                :minute-step="1"
                class="time_picker"
                placeholder="End Time"
                name="showtime"
                id="showtime"
              ></date-picker>-->

              <vue-timepicker
                manual-input
                v-model="end_time2"
                id="endtime"
                name="endtime"
                format="HH:mm"
                placeholder="End Time"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-validate="'required'"
                @change="onChangeTime($event, 'endTime')"
              ></vue-timepicker>
              <!-- <date-picker
                    v-model="end_time"
                    @input="onStockWastageDropDownHandler({ event: $event, name: 'endTime' })"
                    type="time"
                    class="theme-custom-date-time"
                    format="hh:mm a"
                    lang="en"
                    :minute-step="1"
                    typeable
                    v-validate="'required'"
                  ></date-picker> -->
              <!-- <label :class="end_time2 ? 'active' : ''">{{ $t("endtime") }}</label> -->
            </div>
            <!-- <p class="error_msg"></p> -->
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <button
              @click="onFetchStockWasteageReports"
              class="btn-blue-lg w-100"
            >
              {{ $t("getReport") }}
            </button>
          </div>

        <div
          v-if="getStockWastageReport && getStockWastageReport.length > 0"
          class="col-lg-4 col-xl-10 d-flex justify-content-end mb-4 align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getStockWastageReportsPDFFileName"
            :href="BASE_URL + getStockWastageReportsPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getStockWastageReportsExcelFileName"
            :href="BASE_URL + getStockWastageReportsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
        </div>
      </div>

      <div class="swc-report">
        <div
          class="table-auto"
          :class="
            getStockWastageReport && getStockWastageReport.length > 0
              ? 'table-scroll'
              : ''
          "
        >
          <table class="swc-report-table" border="1" style="width: 100%;">
            <thead class style="white-space: nowrap;">
              <tr class="bg-lightgrey">
                <th>{{ $tc("Raw Materials Code") }}</th>
                <th>{{ "Is Item Wastage" }}</th>
                <th>{{ $tc("rawmaterials", 1) }}</th>
                <!-- <th>{{ $tc("vendor", 1) }} {{ $t("name") }}</th> -->
                <th>{{ $tc("user", 1) }}</th>
                <th>{{ $t("location") }}</th>
                <th>{{ $tc("shift", 1) }}</th>
                <th>{{ $t("qty") }}</th>
                <th>UOM</th>
                <th>{{ $t("rate") }}</th>
                <th>{{ $t("net") }} {{ $t("cost") }}</th>
                <th>{{ $t("Tax Amount") }}</th>
                <th>{{ $t("Gross Amount") }}</th>
                <th>{{ $t("date") }}</th>
                <th>{{ $t("time") }}</th>
                <th>{{ $t("remarks") }}</th>
              </tr>
            </thead>
            <tbody
              v-if="getStockWastageReport && getStockWastageReport.length == 0"
            >
              <tr>
                <td colspan="12">
                  <!-- No Records Found -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
            <tbody
              v-if="getStockWastageReport && getStockWastageReport.length > 0"
              class="sph-report"
              style="white-space: nowrap;"
            >
              <tr
                v-for="(stock, stockIndex) in getStockWastageReport"
                :key="stockIndex"
              >
                <td class="text-left">{{ stock.rm_code }}</td>
                <td class="text-left">{{ stock.unique_id ? stock.unique_id : '-' }}</td>
                <td class="text-left">{{ stock.rm_name }}</td>
                <!-- <td>{{ stock.v_name }}</td> -->
                <td class="text-left">{{ stock.user_name }}</td>
                <td class="text-left">{{ stock.sm_store_name }}</td>
                <td class="text-left">{{ stock.shift_name }}</td>
                <td class="text-right">{{ stock.fw_quantity }}</td>
                <td class="text-left">{{ stock.uom_short_form }}</td>
                <td class="text-right">{{ currFormat(stock.rate) }}</td>
                <td class="text-right">{{ currFormat(stock.net_value) }}</td>
                <td class="text-right">
                  {{ currFormat(stock.vr_tax_amount) }}
                </td>
                <td class="text-right">{{ stock.gross_amount.toFixed(2) }}</td>
                <td class="text-left">{{ stock.fw_date | dateparse }}</td>
                <td class="text-left">
                  {{ stock.created_at | format12hours }}
                </td>
                <td class="text-left">{{ stock.fw_reason }}</td>
              </tr>
              <!-- {{getStockWastageReport}} -->
              <tr class="bg-lightgrey">
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th>{{ $t("total") }}</th>
                <th>
                  <!-- {{
                    getStockWastageReport
                      .reduce((acc, { fw_quantity }) => acc + fw_quantity, 0)
                      .toFixed(2)
                  }} -->
                </th>
                <th></th>
                <th class="text-right">
                  <!-- {{
                    getStockWastageReport
                      .reduce((acc, { rate }) => acc + rate, 0)
                      .toFixed(2)
                  }} -->
                </th>

                <th class="text-right">
                  {{
                    currFormat(getStockWastageReport
                      .reduce((acc, { net_value }) => acc + net_value, 0)
                      .toFixed(2))
                  }}
                </th>
                <th class="text-right">
                  {{
                    currFormat(getStockWastageReport
                      .reduce(
                        (acc, { vr_tax_amount }) => acc + vr_tax_amount,
                        0
                      )
                      .toFixed(2))
                  }}
                </th>
                <th class="text-right">
                  {{
                    currFormat(getStockWastageReport
                      .reduce((acc, { gross_amount }) => acc + gross_amount, 0)
                      .toFixed(2))
                  }}
                </th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </tbody>
          </table>
        </div>

         <div
          class="table-auto mt-5"
          :class="
            getStockWastageItemReport && getStockWastageItemReport.length > 0
              ? 'table-scroll'
              : ''
          "
        >
         <div
          v-if="getStockWastageItemReport && getStockWastageItemReport.length > 0"
          class="d-flex justify-content-end mb-4 align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getItemWastageReportsPDFFileName"
            :href="BASE_URL + getItemWastageReportsPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getItemWastageReportsExcelFileName"
            :href="BASE_URL + getItemWastageReportsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
          <table class="swc-report-table" border="1" style="width: 100%;">
            <thead class style="white-space: nowrap;">
              <tr class="bg-lightgrey">
                <th>{{ $tc("Item Wastage Code") }}</th>
                <th>{{ $tc("item", 1) }}</th>
                <th>{{ $t("qty") }}</th>
                <th>{{ $t("location") }}</th>
                <th>{{ $t("Amount") }}</th>
                <th>{{ $t("date") }}</th>
                <th>{{ $t("time") }}</th>
                <th>{{ 'Approved By' }}</th>
                <th>{{ 'Created By' }}</th>
                <th>{{ $t("remarks") }}</th>
              </tr>
            </thead>
            <tbody
              v-if="getStockWastageItemReport && getStockWastageItemReport.length == 0"
            >
              <tr>
                <td colspan="12">
                  <!-- No Records Found -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
            <tbody
              v-if="getStockWastageItemReport && getStockWastageItemReport.length > 0"
              class="sph-report"
              style="white-space: nowrap;"
            >
              <tr
                v-for="(stock, stockIndex) in getStockWastageItemReport"
                :key="stockIndex"
              >
                <td class="text-left">{{ stock.unique_id }}</td>
                <td class="text-left">{{ stock.item_name }}</td>
                <td class="text-left">{{ stock.fiwl_quantity }}</td>
                <td class="text-left">{{ stock.sm_store_name }}</td>
                <td class="text-right">{{ stock.fiwl_amount.toFixed(2) }}</td>
                <td class="text-left">{{ stock.fiwl_date | dateparse }}</td>
                <td class="text-left">
                  {{ stock.created_at | format12hours }}
                </td>
                <td class="text-left">{{ stock.approved_by }}</td>
                <td class="text-left">{{ stock.created_by }}</td>
                <td class="text-left">{{ stock.remark }}</td>
              </tr>
              <tr class="bg-lightgrey">
                <th></th>
                <th>{{ $t("total") }}</th>
                <th>
                  {{
                    getStockWastageItemReport.reduce((acc, { fiwl_quantity }) => acc + fiwl_quantity, 0)
                  }}
                </th>
                <th></th>
                <th class="text-right">
                  {{
                    currFormat(getStockWastageItemReport
                      .reduce((acc, { fiwl_amount }) => acc + fiwl_amount, 0)
                      .toFixed(2))
                  }}
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, VueTimepicker, NoRecords },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      start_time: "",
      end_time: "",
      end_time2: "",
      start_time2: ""
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getStockWastageSelectedCinema",
      "getStockWastageToDate",
      "getStockWastageFromDate",
      "getStockWastageStartTime",
      "getStockWastageEndTime",
      "getStockWastageReport",
      "getStockWastageItemReport",

      // EXCEL
      "getStockWastageReportsExcelFileName",
      // PDF
      "getStockWastageReportsPDFFileName",
      "getItemWastageReportsPDFFileName",
      "getItemWastageReportsExcelFileName",
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onStockWastageDropDownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }

    // this.fetchCinemasList({ cinemaId });
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onStockWastageDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
      }
    }
  },
  methods: {
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onChangeTime(event, type) {
      if (type == "startTime") {
        this.start_time = event.displayTime;
      } else if (type == "endTime") {
        this.end_time = event.displayTime;
      }

      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );

      if (type == "startTime") {
        this.onStockWastageDropDownHandler({ event: event, name: "startTime" });
      } else if (type == "endTime") {
        this.onStockWastageDropDownHandler({ event: event, name: "endTime" });
      }
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onStockWastageDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onFetchStockWasteageReports",
      "onStockWastageDropDownHandler"
    ])
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/stockWastageReport.vue